module.exports = __webpack_public_path__ + "static/media/gordijnen-1.079c08a2.jpg";